import cx from 'classnames';
import typography from '~styles/typography.scss';
import styles from './ServicePage.scss';
import { EventFilterMenu } from './sidePanel/EventFilterMenu';
import { OccupantGroups } from './sidePanel/OccupantGroups';
import { filterOccupantsByEvent } from './sidePanel/utils';
import { useReservationServiceContext } from './state/ReservationServiceContext';
import { useMultiSelectOccupants } from './hooks/useMultiSelectOccupants';
import { OccupantSelectionCheckbox } from './OccupantSelectionCheckbox';
import { useId } from 'react';
import { GuestSearchBar } from 'restaurantAdmin/guestBook/GuestSearchBar';

export const OccupantsSidePanel = () => {
  const {
    occupants: allOccupants,
    handleSetGuestSearchQuery,
    selectedEventId,
  } = useReservationServiceContext();
  const occupants = filterOccupantsByEvent(allOccupants, selectedEventId);
  const {
    isMultiSelectingOccupants,
    multiSelectionOccupantCount,
    updateOccupantMultiSelectionGroup,
  } = useMultiSelectOccupants();
  const multiSelectAllOccupantsId = useId();

  const multiSelectAllOccupants = () => {
    updateOccupantMultiSelectionGroup(occupants);
  };

  return (
    <>
      {isMultiSelectingOccupants ? (
        <div className={styles.multiSelectionCount}>
          <OccupantSelectionCheckbox
            id={multiSelectAllOccupantsId}
            label="All occupants"
            checked={multiSelectionOccupantCount === occupants.length}
            onChange={multiSelectAllOccupants}
          />
          <span className={cx(typography.h6, styles.multiSelectionCountText)}>
            {multiSelectionOccupantCount} Selected
          </span>
        </div>
      ) : (
        <div className={styles.searchBar}>
          <GuestSearchBar onSearch={handleSetGuestSearchQuery} />
          <EventFilterMenu />
        </div>
      )}
      <OccupantGroups />
    </>
  );
};
